document.addEventListener("DOMContentLoaded", function () {
    const ua = navigator.userAgent;

    const isiOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isMacOS = /Macintosh/.test(ua) && navigator.maxTouchPoints === 0;

    if (isiOS || isMacOS) {
      document.body.classList.add("ios-mac");
    }
  });